import { render, staticRenderFns } from "./WidgetBreadcrumbNav.vue?vue&type=template&id=4df4bda4&scoped=true"
import script from "./WidgetBreadcrumbNav.vue?vue&type=script&lang=js"
export * from "./WidgetBreadcrumbNav.vue?vue&type=script&lang=js"
import style0 from "./WidgetBreadcrumbNav.vue?vue&type=style&index=0&id=4df4bda4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df4bda4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/Control-Panel/Control-Panel-Preprod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4df4bda4')) {
      api.createRecord('4df4bda4', component.options)
    } else {
      api.reload('4df4bda4', component.options)
    }
    module.hot.accept("./WidgetBreadcrumbNav.vue?vue&type=template&id=4df4bda4&scoped=true", function () {
      api.rerender('4df4bda4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cpWidget/WidgetBreadcrumbNav.vue"
export default component.exports